
import { supabase } from "@/integrations/supabase/client";

// Define proper types for newsletter subscription results
type SubscriptionResult =
  | { success: true; message: string; type: 'info' | 'success' }
  | { success: false; message: string; type: 'error' };

// Service function that returns data without side effects (no toast calls)
export const subscribeToNewsletter = async (
  email: string, 
  source: string = 'website_footer'
): Promise<SubscriptionResult> => {
  try {
    const { data, error } = await supabase
      .from('newsletter_subscriptions')
      .select('email')
      .eq('email', email)
      .maybeSingle(); // Use maybeSingle to avoid PGRST116 error on no rows

    // Handle unexpected database errors (not "no rows found")
    if (error && error.code !== 'PGRST116') {
      console.error('Supabase query failed:', error);
      return { success: false, message: error.message, type: 'error' };
    }

    // If user is already subscribed
    if (data) {
      return { success: true, message: "Already subscribed", type: "info" };
    }

    // Add new subscriber
    const { error: insertError } = await supabase
      .from('newsletter_subscriptions')
      .insert([
        { email, source }
      ]);

    if (insertError) {
      console.error("Error subscribing to newsletter:", insertError);
      return { success: false, message: insertError.message, type: "error" };
    }

    return { success: true, message: "Subscription successful", type: "success" };
  } catch (error) {
    console.error("Error in newsletter subscription:", error);
    return { success: false, message: "Unexpected error", type: "error" };
  }
};
